<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranihPodatkovStranke="GetStranka" />
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div>
          <EposlovanjeComponent
            :izbranaStranka="izbranaStranka"
            :izbranaStrankaSap="izbranaStrankaSap"/>
        </div>
        <div>
          <permission-component
            :permission-id="'PRIKLJUCKI'"
            :parameter-key="'id_stranka'"
            :parameter-value="izbranaStranka">
            <EracunComponent
                :izbranaStranka="izbranaStranka"
                :izbranaStrankaSap="izbranaStrankaSap" />
          </permission-component>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import EposlovanjeComponent from './Eposlovanje/EposlovanjeComponent.vue'
import EracunComponent from './Eposlovanje/EracunComponent'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'
import PermissionComponent from '../GlobalneKomponente/PermissionComponent'

export default {
  name: 'eposlovanje',
  mixins: [GetPodatkiIzbirnika],
  data () {
    return {
      clientAgent: null,
      izbranaStrankaSap: '',
      izbranaStranka: ''
    }
  },
  components: {
    'IzbirnikStranke': IzbirnikStranke,
    'EposlovanjeComponent': EposlovanjeComponent,
    'EracunComponent': EracunComponent,
    PermissionComponent
  },
  mounted () {
    this.clientAgent = new ClientAgent()
  },
  methods: {
    GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.izbranaStranka = podatkiStranke.id_stranka
        this.izbranaStrankaSap = podatkiStranke.id_stranka_sap
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Eposlovanje.vue